// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--VRb5f";
export var footerContainer = "Footer-module--footer-container--3nxF5";
export var footerItem = "Footer-module--footer-item--1apAa";
export var iconLink = "Footer-module--icon-link--3yTll";
export var link = "Footer-module--link--3kRZy";
export var credits = "Footer-module--credits--33YcZ";